import { render, staticRenderFns } from "./NumberForm.vue?vue&type=template&id=05432e84"
import script from "./NumberForm.vue?vue&type=script&lang=js"
export * from "./NumberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports